<template>
    <section class="changeLang">
        <div class="lang-switch" @click="toggleLang" :title="currentLang === 'zh_CN' ? '切换到 English' : 'Switch to 中文'">
            <span class="lang-option" :class="{ active: currentLang === 'zh_CN' }">中</span>
            <span class="lang-option" :class="{ active: currentLang === 'en_US' }">EN</span>
            <span class="lang-slider" :class="{ 'is-en': currentLang === 'en_US' }"></span>
        </div>
    </section>
</template>

<script>
import { generateTitle } from '@/utils/i18n';
import { STORAGE_PREFIX } from '../../config/storage';
export default {
    inject: ['reload'],
    computed: {
        language() {
            return this.$store.getters.language;
        },
        currentLang() {
            return this.$i18n && this.$i18n.locale;
        }
    },
    methods: {
        toggleLang() {
            const newLang = this.currentLang === 'zh_CN' ? 'en_US' : 'zh_CN';
            this.$i18n.locale = newLang;
            // 语言切换后保持浏览器标签 title 为固定的系统名称
            document.title = this.$t('system.Cold_chain_system');
            this.$store.dispatch('app/setLanguage', newLang);
            localStorage.setItem(STORAGE_PREFIX + 'lang', newLang);
        }
    }
};
</script>
<style lang="scss" scoped>
.changeLang {
    display: flex;
    align-items: center;
}

/* 中英文切换 - 滑动式 toggle switch（适配深色 top bar） */
.lang-switch {
    position: relative;
    display: inline-flex;
    align-items: center;
    width: 64px;
    height: 24px;
    padding: 2px;
    border-radius: 999px;
    background-color: rgba(255, 255, 255, 0.15);
    cursor: pointer;
    user-select: none;
    overflow: hidden;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);
    outline: none;
    transition: background-color 0.25s ease;

    &:hover {
        background-color: rgba(255, 255, 255, 0.22);
    }

    &:focus,
    &:active {
        outline: none;
    }

    .lang-option {
        position: relative;
        z-index: 2;
        flex: 1;
        text-align: center;
        font-size: 11px;
        font-weight: 500;
        line-height: 20px;
        color: rgba(255, 255, 255, 0.55);
        background-color: transparent;
        transition: color 0.25s ease;

        &.active {
            color: #fff;
            font-weight: 600;
            background-color: transparent;
        }
    }

    .lang-slider {
        position: absolute;
        top: 2px;
        left: 2px;
        z-index: 1;
        width: calc(50% - 2px);
        height: calc(100% - 4px);
        border-radius: 999px;
        background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-color-hover) 100%);
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
        transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1), background 0.25s ease;

        &.is-en {
            transform: translateX(100%);
        }
    }

    &:hover .lang-slider {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
    }
}
</style>
